import PropTypes from 'prop-types'

// Status colour as text on a faint tint of the same hue. Every pair passes
// AA (4.5:1 and up). The live tone prints in live-deep: live itself is
// 3.4:1 on white, too light for small text.
const TONES = {
  live: 'text-live-deep bg-live/10',
  ink: 'text-ink bg-ink/[0.06]',
  blue: 'text-rule-blue bg-rule-blue/10',
  ok: 'text-status-ok bg-status-ok/10',
  wait: 'text-status-wait bg-status-wait/10',
  bad: 'text-status-bad bg-status-bad/10',
  // A status that is over or off (closed, ended, withdrawn).
  faint: 'text-ink-mute bg-ink/[0.04]',
}

const SIZES = {
  sm: 'text-sm',
  md: 'text-base px-2.5 py-1',
  lg: 'text-lg px-3 py-1',
}

/**
 * A flat status label: Barlow semibold in the tone's colour on a faint tint
 * of it, 4px corners, no rotation. `tone="live"` needs the person now;
 * `ink` is neutral; `blue` a note; `ok`, `wait` and `bad` the status inks; `faint` a status that is over.
 * A status word should go through `StatusStamp`, which picks the tone from
 * the shared status map. `pressed` and `tilt` are accepted for older
 * callers and ignored.
 */
export default function Stamp({
  children,
  tone = 'live',
  size = 'md',
  // eslint-disable-next-line no-unused-vars
  pressed,
  // eslint-disable-next-line no-unused-vars
  tilt,
  className = '',
  ...rest
}) {
  return (
    <span
      className={`stamp ${TONES[tone] || TONES.ink} ${SIZES[size] || SIZES.sm} ${className}`}
      {...rest}
    >
      {children}
    </span>
  )
}

Stamp.propTypes = {
  children: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(['live', 'ink', 'blue', 'ok', 'wait', 'bad', 'faint']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  // No longer animate or rotate; kept so existing callers need no change.
  pressed: PropTypes.bool,
  tilt: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
}
